export interface SharePayload {
  title: string;
  text: string;
  url?: string;
}

export type ShareResult = "shared" | "copied" | "cancelled";

export function precisePlateSharePayload(): SharePayload {
  return {
    title: "Precise Plate",
    text: "Plan science-backed meals around your nutrition goals with Precise Plate.",
    url: publicAppUrl(),
  };
}

export function mealSharePayload(meal: {
  name: string;
  slotLabel?: string | null;
  nutrition?: { calories?: number | null; protein?: number | null };
  ingredients?: Array<{ ingredientName: string; grams: number }>;
}): SharePayload {
  const nutrition = meal.nutrition ?? {};
  const facts = [
    nutrition.calories == null ? null : `${Math.round(Number(nutrition.calories))} kcal`,
    nutrition.protein == null ? null : `${Math.round(Number(nutrition.protein))} g protein`,
  ].filter(Boolean).join(" | ");
  const ingredients = (meal.ingredients ?? [])
    .slice(0, 12)
    .map((ingredient) => `${ingredient.ingredientName} (${Math.round(ingredient.grams)} g)`)
    .join(", ");
  const lines = [
    meal.slotLabel ? `${meal.slotLabel}: ${meal.name}` : meal.name,
    facts,
    ingredients ? `Ingredients: ${ingredients}` : "",
    "Created with Precise Plate.",
  ].filter(Boolean);
  return { title: meal.name, text: lines.join("\n"), url: publicAppUrl() };
}

export async function shareContent(payload: SharePayload): Promise<ShareResult> {
  if (typeof navigator.share === "function") {
    try {
      await navigator.share(payload);
      return "shared";
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") return "cancelled";
    }
  }

  const fallback = [payload.text, payload.url].filter(Boolean).join("\n\n");
  await navigator.clipboard.writeText(fallback);
  return "copied";
}

function publicAppUrl(): string {
  return publicAppPath("/");
}
import { publicAppPath } from "../platform";
